import LazyImages from './LazyImages';
const MOBILE_MAX_WIDTH = 480;
const SLIDE_DURATION_MS = 400;
export default (() => {
    console.log('UNTUCKit : Module : Article : loaded');
    const isMobile = () => document.documentElement.clientWidth <= MOBILE_MAX_WIDTH;
    const isHidden = (element) => getComputedStyle(element).display === 'none';
    const runAnimation = (element, keyframes, duration, complete) => {
        if (typeof element.animate !== 'function') {
            complete();
            return;
        }
        const animation = element.animate(keyframes, {
            duration,
            easing: 'ease',
            fill: 'forwards',
        });
        animation.onfinish = () => {
            animation.cancel();
            complete();
        };
    };
    const slideUp = (element, duration = SLIDE_DURATION_MS) => {
        const computed = getComputedStyle(element);
        runAnimation(element, [
            { height: computed.height, paddingTop: computed.paddingTop, paddingBottom: computed.paddingBottom, marginTop: computed.marginTop, marginBottom: computed.marginBottom },
            { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px' },
        ], duration, () => {
            element.style.display = 'none';
            element.style.height = '';
            element.style.padding = '';
            element.style.margin = '';
        });
    };
    const slideDown = (element, duration = SLIDE_DURATION_MS) => {
        element.style.display = 'block';
        const computed = getComputedStyle(element);
        const targetHeight = `${element.scrollHeight}px`;
        element.style.height = '0px';
        runAnimation(element, [
            { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px' },
            { height: targetHeight, paddingTop: computed.paddingTop, paddingBottom: computed.paddingBottom, marginTop: computed.marginTop, marginBottom: computed.marginBottom },
        ], duration, () => {
            element.style.height = '';
            element.style.padding = '';
            element.style.margin = '';
        });
    };
    const slideToggle = (element, duration) => {
        if (isHidden(element)) {
            slideDown(element, duration);
        }
        else {
            slideUp(element, duration);
        }
    };
    const fetchHtml = (url) => fetch(url)
        .then((response) => {
        if (!response.ok) {
            throw new Error(`Request failed: ${response.status}`);
        }
        return response.text();
    });
    function getMoreArticles() {
        const nextButtons = document.querySelectorAll('.js-next');
        const getURL = nextButtons[0]?.getAttribute('data-paginate');
        if (!getURL) {
            return;
        }
        fetchHtml(getURL)
            .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const returnedArticles = parsed.querySelector('#blog-grid__article-container');
            const articleContainer = document.querySelector('#blog-grid__article-container');
            if (returnedArticles && articleContainer) {
                articleContainer.append(...Array.from(returnedArticles.children));
            }
            const returnedNext = parsed.querySelector('.js-next');
            if (returnedNext) {
                const newNextData = returnedNext.getAttribute('data-paginate');
                nextButtons.forEach((button) => {
                    if (newNextData) {
                        button.setAttribute('data-paginate', newNextData);
                    }
                });
            }
            else {
                nextButtons.forEach((button) => button.remove());
            }
            LazyImages.update();
        })
            .catch(() => { });
    }
    function getArticleTableData(table) {
        const tableData = [];
        table.querySelectorAll('tr').forEach((row) => {
            const shopLookObj = {};
            row.querySelectorAll('td').forEach((cell) => {
                const imgSrc = cell.querySelector('img')?.getAttribute('src');
                if (imgSrc) {
                    shopLookObj.lookImage = imgSrc;
                }
                else {
                    shopLookObj.lookProducts = cell.textContent ?? '';
                }
            });
            tableData.push(shopLookObj);
        });
        return tableData;
    }
    function getArticleSTLImageData(image) {
        const stlImageData = [];
        const shopLookObj = {};
        const products = image.getAttribute('products');
        stlImageData.lookImage = image.getAttribute('src') ?? undefined;
        if (products) {
            shopLookObj.lookProducts = products;
            stlImageData.push(shopLookObj);
        }
        console.log(shopLookObj);
        return stlImageData;
    }
    function element(tag, className) {
        const node = document.createElement(tag);
        node.className = className;
        return node;
    }
    function buildTheLook(arr) {
        const stlContainer = element('div', `shop-the-look-container shop-the-look-${arr.length}`);
        arr.forEach((item) => {
            const imgBlock = element('div', 'shop-the-look__look-item-img');
            imgBlock.style.backgroundImage = `url(${item.lookImage})`;
            imgBlock.insertAdjacentHTML('beforeend', '<p class="js-open-stl">Shop The Look</p>');
            const shopItemWrapper = element('div', 'shop-the-look__item-wrapper');
            shopItemWrapper.append(imgBlock);
            shopItemWrapper.insertAdjacentHTML('beforeend', '<div class="stl-scroll"><span class="down-arrow"></span></div>');
            const shopItemsContainer = element('div', 'shop-the-look__items-container');
            shopItemsContainer.insertAdjacentHTML('beforeend', '<p class="js-close-stl">&times;</p>');
            shopItemWrapper.append(shopItemsContainer);
            stlContainer.append(shopItemWrapper);
            appendStlItems(shopItemsContainer, item.lookProducts);
        });
        return stlContainer;
    }
    function buildTheLookDrawer(arr) {
        const drawerContainer = element('div', 'shop-the-look-drawer');
        const drawerCloseObject = element('span', 'shop-the-look-drawer-close');
        arr.forEach((item) => {
            const products = item.lookProducts ?? '';
            const shopItemsContainer = element('div', `shop-the-look-drawer-items item-count-${products.split(',').length}`);
            drawerContainer.append(shopItemsContainer);
            appendStlItems(shopItemsContainer, products);
        });
        drawerContainer.insertAdjacentHTML('beforeend', '<div class="stl-divider"></div>');
        drawerContainer.append(drawerCloseObject);
        return drawerContainer;
    }
    function appendStlItems(container, productList) {
        if (!productList) {
            return;
        }
        productList.split(',').forEach((item) => {
            const requestUrl = `/products/${item}?view=stl`;
            fetchHtml(requestUrl)
                .then((html) => {
                container.insertAdjacentHTML('beforeend', html);
                LazyImages.update();
            })
                .catch(() => { });
        });
    }
    function close(trigger) {
        const itemWrapper = trigger.closest('.shop-the-look__items-container');
        if (!itemWrapper) {
            return;
        }
        if (isMobile()) {
            slideUp(itemWrapper);
        }
        else {
            const computed = getComputedStyle(itemWrapper);
            runAnimation(itemWrapper, [
                { height: computed.height, padding: computed.padding, borderWidth: computed.borderWidth },
                { height: '0px', padding: '0px', borderWidth: '0px' },
            ], 300, () => {
                itemWrapper.style.height = '0px';
                itemWrapper.style.padding = '0px';
                itemWrapper.style.borderWidth = '0px';
            });
        }
        trigger.closest('.shop-the-look__item-wrapper')?.querySelector('.stl-scroll')?.classList.remove('active');
    }
    function open(trigger) {
        const itemWrapper = trigger.closest('.shop-the-look__item-wrapper')?.querySelector('.shop-the-look__items-container');
        if (!itemWrapper) {
            return;
        }
        if (isMobile()) {
            itemWrapper.style.height = '100%';
            itemWrapper.style.padding = '10px 10px 5px';
            itemWrapper.style.borderWidth = '1px';
            itemWrapper.style.display = 'none';
            slideDown(itemWrapper);
        }
        else {
            if (isHidden(itemWrapper)) {
                itemWrapper.style.display = 'block';
            }
            runAnimation(itemWrapper, [
                { height: '0px', padding: '0px', borderWidth: '0px' },
                { height: '100%', padding: '10px 10px 5px', borderWidth: '1px' },
            ], 300, () => {
                itemWrapper.style.height = '100%';
                itemWrapper.style.padding = '10px 10px 5px';
                itemWrapper.style.borderWidth = '1px';
                itemWrapper.style.overflow = 'scroll';
            });
        }
        if (itemWrapper.scrollHeight > 500) {
            itemWrapper.classList.add('active');
        }
    }
    function init() {
        console.log('UNTUCKit : Module : Article : init');
        document.querySelectorAll('.js-next').forEach((button) => {
            button.addEventListener('click', getMoreArticles);
        });
        const articleBody = document.querySelector('.article-body');
        if (articleBody) {
            articleBody.querySelectorAll('table').forEach((table) => {
                const shopObjects = getArticleTableData(table);
                table.parentElement?.replaceChildren(buildTheLook(shopObjects));
            });
            articleBody.querySelectorAll('img.shop-the-look-image').forEach((image) => {
                const shopObjects = getArticleSTLImageData(image);
                const openDrawer = element('div', 'shop-the-look-drawer-open');
                openDrawer.insertAdjacentHTML('beforeend', '<div class="stl-divider"></div><div class="stl-button"><span>Shop The Look</span><span class="icon-arrow"></span></div>');
                openDrawer.addEventListener('click', () => {
                    const parent = openDrawer.parentElement;
                    parent?.classList.toggle('button-hidden');
                    const drawer = parent?.querySelector('.shop-the-look-drawer');
                    if (drawer) {
                        slideToggle(drawer, 300);
                    }
                });
                image.parentElement?.append(openDrawer, buildTheLookDrawer(shopObjects));
            });
            articleBody.addEventListener('click', (event) => {
                if (!(event.target instanceof Element)) {
                    return;
                }
                const closeTrigger = event.target.closest('.js-close-stl');
                if (closeTrigger) {
                    close(closeTrigger);
                    return;
                }
                const openTrigger = event.target.closest('.js-open-stl');
                if (openTrigger) {
                    open(openTrigger);
                }
            });
        }
        const blogContainer = document.querySelector('#blog-collection__article-container');
        blogContainer?.addEventListener('click', (event) => {
            if (!(event.target instanceof Element)) {
                return;
            }
            const trigger = event.target.closest('.js-blog-next');
            if (!trigger || !blogContainer.contains(trigger)) {
                return;
            }
            event.preventDefault();
            const href = trigger.dataset.href;
            if (!href) {
                return;
            }
            trigger.classList.add('is-loading');
            fetchHtml(href)
                .then((html) => {
                trigger.remove();
                blogContainer.insertAdjacentHTML('beforeend', html);
                LazyImages.update();
            })
                .catch(() => { });
        });
    }
    return { init };
})();
